import React from "react";
import "../styles/Guidelines.css";

const Guidelines = () => {
  return (
    <article className="guideline-cont">
        <div className="guidelines-container">
      <h1 className="title">Innovastra Hackathon Guidelines</h1>

      <section className="guideline-section">
        <h2>1. Team Formation</h2>
        <ul>
          <li>Inter-college teams are allowed, encouraging diversity and cross-institutional collaboration.</li>
          <li>Each team must consist of2 to 4 members to ensure efficiency and collaboration.</li>
        </ul>
        <p className="tip">Tip: Choose teammates with complementary skills (coding, UI/UX, presentation) to maximize your potential!</p>
      </section>

      <section className="guideline-section">
        <h2>2. Problem Statement & Duration</h2>
        <ul>
          <li>The Problem Statement will be revealed on the spot at the start of the hackathon.</li>
          <li>The event will last for 24 hours, so teams must manage their time wisely.</li>
        </ul>
        <p className="tip">Time management is key! Allocate time for ideation, coding, testing, and final presentation to avoid last-minute panic.</p>
      </section>

      <section className="guideline-section">
        <h2>3. Equipment & Resources</h2>
        <ul>
          <li>Participants must bring their own laptops, chargers, and software/tools.</li>
          <li>Internet access will be provided, but originality is crucial.</li>
        </ul>
        <p className="tip">Ensure your development environment is set up in advance to avoid delays.</p>
      </section>

      <section className="guideline-section">
        <h2>4. Judging Criteria</h2>
        <ul>
          <li>Innovation: Uniqueness and creativity in solving the problem.</li>
          <li>Feasibility: Practical implementation and scalability potential.</li>
          <li>Implementation: Code quality, functionality, and execution.</li>
          <li>Presentation: Clarity and effectiveness in explaining the solution.</li>
        </ul>
        <p className="tip">Balance technical excellence with clear communication. Be ready for judges' questions!</p>
      </section>

      <section className="guideline-section">
        <h2>5. Development Rules</h2>
        <ul>
          <li>All work must be done during the hackathon; pre-built projects are not allowed.</li>
          <li>Teams may use open-source libraries, APIs, and frameworks, but plagiarism is prohibited.</li>
          <li>Active participation from all members is required.</li>
        </ul>
        <p className="tip">Use version control (GitHub) to collaborate efficiently.</p>
      </section>

      <section className="guideline-section">
        <h2>6. Conduct & Fair Play</h2>
        <ul>
          <li>Respect fellow participants, mentors, and organizers.</li>
          <li>Any form of cheating or misconduct will lead to disqualification.</li>
          <li>Maintain a positive and professional attitude throughout the event.</li>
        </ul>
        <p className="tip">🤝 The goal is to learn, innovate, and have fun. Compete with integrity!</p>
      </section>

      <section className="guideline-section">
        <h2>7. Submission & Final Presentation</h2>
        <ul>
          <li>Submit your project within the deadline—late submissions will not be accepted.</li>
          <li>Teams must provide a brief presentation/demo explaining their solution.</li>
          <li>Judges may ask technical and non-technical questions.</li>
        </ul>
        <p className="tip">Keep your presentation clear, concise, and impactful!</p>
      </section>

      <section className="guideline-section">
        <h2>Refund Guidelines</h2>
        <p className="tip">No Refund will be provided if you fails to make your entry/presence in the Hackathon.</p>
      </section>

      <div className="guideline-downloads">
        <a
          href="/assets/Innovastra-2025_28022025_Hackathon_Guidelines.pdf"
          download="Innovastra-2025_28022025_Hackathon_Guidelines"
          className="download-btn"
        >
          Download Guidelines PDF
        </a>
      </div>
        
        <div className="rules-and-regulation">
        <a
          href="/assets/Innovastra-2025_28022025_Hackathon_Rules_&_regulations.pdf"
          download="Innovastra-2025_28022025_Hackathon_Rules_&_regulations"
          className="download-btn"
        >
          Download Rules & Regulations PDF
        </a>
      </div>

      <section className="final-words">
        <h2>Final Words</h2>
        <p>
          This hackathon is not just about winning—it’s about learning, networking, and building something meaningful.  
          Collaborate, think creatively, and enjoy the experience!  
        </p>
        <p>Follow these guidelines to have a smooth and fair competition. Best of luck, and happy hacking! 🎯</p>
        <p>Good luck and have fun during the hackathon!</p>
        <p>Best Regards,<br></br>Team Innovastra</p>
      </section>
    </div>
    </article>
  );
};

export default Guidelines;
